import { render } from "./TableConfiguration.vue?vue&type=template&id=4dceaf72"
import script from "./TableConfiguration.vue?vue&type=script&lang=js"
export * from "./TableConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__